import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DependencyTrackerClass;
function DependencyTracker() {
  if (DependencyTrackerClass === VOID) {
    class $ {
      constructor() {
        this.dependencies_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.usedDependencies_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      existingDependency_tkmz95_k$(listenable) {
        var index = this.usedDependencies_1.get_size_woubt6_k$();
        if (index < this.dependencies_1.get_size_woubt6_k$()) {
          var maybe = this.dependencies_1.get_c1px32_k$(index).first_1;
          if (equals(maybe, listenable)) {
            this.usedDependencies_1.add_utx5q5_k$(listenable);
            return !(maybe == null) ? maybe : THROW_CCE();
          }
        }
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.dependencies_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (equals(element.first_1, listenable)) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.first_1;
        var found = !(tmp == null) ? tmp : null;
        if (!this.usedDependencies_1.contains_aljjnj_k$(listenable)) {
          this.usedDependencies_1.add_utx5q5_k$(listenable);
        }
        return found;
      }
      registerDependency_23xa5k_k$(any, remove) {
        var tmp0 = this.dependencies_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = to(any, remove);
        tmp0.add_utx5q5_k$(element);
      }
      cancel_2l89ey_k$() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.dependencies_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          element.second_1();
        }
        this.dependencies_1.clear_j9egeb_k$();
      }
      dependencyBlockStart_qxo3ow_k$() {
        this.usedDependencies_1.clear_j9egeb_k$();
      }
      dependencyBlockEnd_6wfk9j_k$() {
        var iter = this.dependencies_1.iterator_jk1svi_k$();
        while (iter.hasNext_bitz1p_k$()) {
          var entry = iter.next_20eer_k$();
          if (!this.usedDependencies_1.contains_aljjnj_k$(entry.first_1)) {
            entry.second_1();
            iter.remove_ldkf9o_k$();
          }
        }
      }
    }
    initMetadataForClass($, 'DependencyTracker');
    DependencyTrackerClass = $;
  }
  return DependencyTrackerClass;
}
//region block: exports
export {
  DependencyTracker as DependencyTracker2tg9lout2xnpn,
};
//endregion

//# sourceMappingURL=DependencyTracker.mjs.map
